<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      :show-paid-only="false"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <!-- صف کارهای محتوایی: مستقل از بازه، چون سؤال «چقدر عقبیم» است -->
    <b-row class="match-height">
      <b-col
        v-for="(item, index) in pending"
        :key="item.Key"
        md="4"
        cols="12"
        class="mb-1"
      >
        <kpi-card
          :kpi="item"
          :skin="skin"
          :color-index="index"
          :compact="false"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="publishing"
          title="تولید محتوا و مشارکت"
          subtitle="مقاله بر اساس تاریخ انتشار شمرده می‌شود"
          :metrics="['blogs', 'projects', 'comments']"
          type="bar"
          :height="300"
          :loading="loading('publishing')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="topBlogs"
          title="پربازدیدترین مقاله‌ها"
          :subtitle="rangeLabel"
          label-title="مقاله"
          show-image
          :loading="loading('topBlogs')"
          :route-for="blogRoute"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportContent',
  mixins: [reportMixin],
  data() {
    return {
      publishing: null,
      topBlogs: null,
      pending: [],
    }
  },
  computed: {
    compareLabel() {
      return this.publishing && this.publishing.CompareRange
        ? this.publishing.CompareRange.Label
        : null
    },
  },
  created() {
    this.filter.PaidOnly = false
    this.refresh()

    this.$http.post(this.$api.report.contentPending, {})
      .then(res => { this.pending = res.data || [] })
      .catch(() => {})
  },
  methods: {
    refresh() {
      this.fetchReport('publishing', this.$api.report.contentPublishing)
      this.fetchReport('topBlogs', this.$api.report.contentTopBlogs)
    },

    blogRoute(row) {
      return row.Id ? { name: 'updateblog', params: { id: row.Id } } : null
    },
  },
}
</script>
